import { useNavigate } from "react-router-dom";
import { COMPONENTS_LessonCom } from "../../assets/asset";

const YearCompletionPopup = () => {
  const navigate = useNavigate();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50">
      <div
        className="relative w-[90%] max-w-md aspect-[3/4] bg-no-repeat bg-contain bg-center flex flex-col justify-end items-center"
        style={{
          backgroundImage: `url(${COMPONENTS_LessonCom.year_completion_popup})`,
        }}
      >
        <button
          onClick={() => navigate("/yearsdashboard")}
          className="mb-4"
        >
          <img
            src={COMPONENTS_LessonCom.red_continue_button}
            alt="Continue"
            className="w-36 sm:w-48 mx-auto"
          />
        </button>
      </div>
    </div>
  );
};

export default YearCompletionPopup;
